import React, { useEffect, useState } from 'react';
import {
  Box, Button, TextField, Typography, Dialog, DialogTitle, DialogContent, DialogActions
} from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import axios from 'axios';
import LayoutAdminHeader from '../components/LayoutAdminHeader';
import LayoutAdminFooter from '../components/LayoutAdminFooter';

const BASE_URL = process.env.REACT_APP_BASE_URL || '';

const Discount = () => {
  const [discounts, setDiscounts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [open, setOpen] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [form, setForm] = useState({
    amount: '',
    discountPercent: '',
    tillLastTransaction: ''
  });

  const fetchDiscounts = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem("token");

const res = await axios.get(`${BASE_URL}/Discount/GetActiveDiscount`, {
  headers: {
    Authorization: `Bearer ${token}`,
  },
});
      const data = res.data.data;
      if (data) {
        setDiscounts([data]);
      } else {
        setDiscounts([]);
      }
    } catch (err) {
      toast.error('Failed to load discounts');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDiscounts();
  }, []);

  const handleOpen = () => {
    setEditMode(false);
    setForm({
      amount: '',
      discountPercent: '',
      tillLastTransaction: ''
    });
    setOpen(true);
  };

  const handleEdit = () => {
    if (discounts.length > 0) {
      const d = discounts[0];
      setForm({
        amount: d.amount,
        discountPercent: d.discountPercent,
        tillLastTransaction: d.tillLastTransaction
      });
      setEditMode(true);
      setOpen(true);
    }
  };

  const handleSave = async () => {
    try {
      const payload = {
        amount: Number(form.amount),
        discountPercent: Number(form.discountPercent),
        tillLastTransaction: Number(form.tillLastTransaction)
      };

      if (editMode && discounts.length > 0) {
        const token = localStorage.getItem("token");

const res = await axios.put(
  `${BASE_URL}/Discount/UpdateDiscount/${discounts[0].id}`,
  payload,
  {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  }
);
        toast.success('Discount updated successfully');
      } else {
        const token = localStorage.getItem("token");

const res = await axios.post(
  `${BASE_URL}/Discount/AddDiscount`,
  payload,
  {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  }
);
        toast.success('Discount added successfully');
      }

      setOpen(false);
      fetchDiscounts();
    } catch (err) {
      const message = err?.response?.data?.message || 'Failed to save discount';
      toast.error(message);
    }
  };

  const columns = [
    // { field: 'id', headerName: 'ID', flex: 1 },
    { field: 'amount', headerName: 'Amount', flex: 1 },
    { field: 'discountPercent', headerName: 'Discount %', flex: 1 },
    { field: 'tillLastTransaction', headerName: 'Till Last Txn', flex: 1 },
    {
      field: 'actions',
      headerName: 'Actions',
      flex: 1,
      sortable: false,
      renderCell: () => (
        <>
          <Button variant="outlined" color="primary" size="small" onClick={handleEdit}>
            Edit
          </Button>
        </>
      )
    }
  ];

  return (
    <>
    <LayoutAdminHeader />
    <Box p={3}>
      <ToastContainer position="top-right" autoClose={3000} />
      <Typography variant="h5" gutterBottom>
        Discount Management
      </Typography>

      {/* <Box mb={2} display="flex" justifyContent="flex-end">
        <Button variant="contained" color="primary" onClick={handleOpen}>
          {discounts.length > 0 ? 'Add New Discount' : 'Create Discount'}
        </Button>
      </Box> */}

      <DataGrid
        autoHeight
        rows={discounts}
        columns={columns}
        pageSize={5}
        rowsPerPageOptions={[5]}
        loading={loading}
        disableSelectionOnClick
      />

      <Dialog open={open} onClose={() => setOpen(false)}>
        <DialogTitle>{editMode ? 'Edit Discount' : 'Add Discount'}</DialogTitle>
        <DialogContent>
          <TextField
            label="Amount"
            fullWidth
            margin="dense"
            value={form.amount}
            onChange={(e) => setForm({ ...form, amount: e.target.value })}
            type="number"
          />
          <TextField
            label="Discount Percent"
            fullWidth
            margin="dense"
            value={form.discountPercent}
            onChange={(e) => setForm({ ...form, discountPercent: e.target.value })}
            type="number"
          />
          <TextField
            label="Till Last Transaction"
            fullWidth
            margin="dense"
            value={form.tillLastTransaction}
            onChange={(e) => setForm({ ...form, tillLastTransaction: e.target.value })}
            type="number"
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpen(false)}>Cancel</Button>
          <Button variant="contained" onClick={handleSave}>
            {editMode ? 'Update' : 'Add'}
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
        </>
  );
};

export default Discount;
